/**
 * Prev/next arrows for homepage rows that turn into swipe sliders on mobile
 * (most-loved products, collection tiles). Markup:
 *   <div data-scroll-arrows>
 *     <ul data-scroll-track>…</ul>
 *     <button data-scroll-prev>…</button> <button data-scroll-next>…</button>
 *   </div>
 * Each click scrolls by one item; arrows disable at either end.
 */
function initScrollArrows(root) {
  // The snippet loads this script once per section that uses it.
  if (root.dataset.scrollArrowsReady) return;
  root.dataset.scrollArrowsReady = 'true';

  const track = root.querySelector('[data-scroll-track]');
  const prev = root.querySelector('[data-scroll-prev]');
  const next = root.querySelector('[data-scroll-next]');
  if (!track || !prev || !next) return;

  const step = () => track.firstElementChild?.getBoundingClientRect().width || track.clientWidth;
  const update = () => {
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
  };

  prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

document.querySelectorAll('[data-scroll-arrows]').forEach(initScrollArrows);
